import { render } from "./ExchangeRate.vue?vue&type=template&id=0eaedeb3&scoped=true"
import script from "./ExchangeRate.vue?vue&type=script&lang=js"
export * from "./ExchangeRate.vue?vue&type=script&lang=js"

import "./ExchangeRate.vue?vue&type=style&index=0&id=0eaedeb3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eaedeb3"]])

export default __exports__